import { CSSProperties } from "@material-ui/core/styles/withStyles";
import ReactPlayer from "react-player";
import dataScience from "../../assets/images/dataScience.jpg";
import Player from "../../utils/controlls/Player";

export default function acerca() {
  //region styles
  const divContenedorAD: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  };
  //endregion styles

  return (
    <div style={divContenedorAD}>
      <h2 className="sectionTitle">
        Unidad de Información y Estadística Jurisdiccional
      </h2>
      <Player />
      <div>
        <p className="sectionTitle" style={{ fontWeight: "bold" }}>
          ¿Qué hace la Unidad Estadística e Información Jurisdiccional del
          Tribunal Electoral del Poder Judicial de la Federación?
        </p>
        <p>
          Su objetivo es desarrollar y difundir la información estadística de la
          actividad jurisdiccional del Tribunal Electoral, elaborar los estudios
          estadísticos de carácter técnico que coadyuven en la toma de
          decisiones y la planeación de la actividad jurisdiccional, coordinar y
          supervisar el debido control y registro de los asuntos ingresados y
          desahogados por las Salas del Tribunal Electoral, así como otras
          actividades relacionadas con la generación de información estadística.
        </p>
      </div>
    </div>
  );
}
